import { useEffect, useState } from 'react'
import { Input, Button } from 'reactstrap'
import { isNull } from '../../izUtils'

const PaginationTop = ({filters, getData}) => {
    const [inputs, setInputs] = useState(null)

    useEffect(() => {
        setInputs(filters)

    }, [filters])

    const textChange = (value, name) => {
        let clonedInputs = {...inputs}
        clonedInputs[name].value = value;
        if (!isNull(clonedInputs['pagination_page'])) clonedInputs['pagination_page'].value = 1;

        if (name === 'table_search') {
            setInputs(clonedInputs)
        } else {
            getData(clonedInputs)
        }
    }

    const handleKeyDown = (e, name) => {
        if (e.keyCode === 13) {
            let clonedInputs = {...inputs}
            clonedInputs[name].value = e.target.value;
            getData(clonedInputs)
        }
    }

    const deleteTableSearch = () => {
        let clonedInputs = {...inputs}
        clonedInputs['table_search'].value = "";
        getData(clonedInputs)
    }

    if (!isNull(inputs)) {
        return (
            <div className='d-flex align-items-center justify-content-between flex-wrap mb-3'>
                <div className='d-flex align-items-center'>
                    <div className='me-2'>{inputs['pagination_show_per_page'].title}</div>
                    <Input
                        className='pagination-select'
                        type="select"
                        name={inputs['pagination_show_per_page'].name}
                        value={inputs['pagination_show_per_page'].value}
                        disabled={inputs['pagination_show_per_page'].disabled}
                        onChange={(e) => textChange(e.target.value, 'pagination_show_per_page')}
                    >
                        {inputs['pagination_show_per_page'].values.map((option, index) => (
                            <option key={index} value={option.id}>{option.title}</option>
                        ))}
                    </Input>
                </div>
                {(!isNull(inputs['table_search']) && inputs['table_search'].display) &&
                    <div className='d-flex align-items-center'>
                        <div className='position-relative'>
                            <Input
                                className='table-search'
                                type="text"
                                name={inputs['table_search'].name}
                                value={isNull(inputs['table_search'].value) ? '' : inputs['table_search'].value}
                                disabled={inputs['table_search'].disabled}
                                onChange={(e) => textChange(e.target.value, 'table_search')}
                                onKeyDown={(e) => handleKeyDown(e, 'table_search')}
                                placeholder={inputs['table_search'].title}
                            />
                            <button className='delete-table-search' onClick={deleteTableSearch}>&#10006;</button>
                        </div>
                        <Button size="sm" className="ms-2" onClick={() => getData(inputs)}>Išči</Button>
                    </div>
                }
            </div>
        )
    }
}

export default PaginationTop